import React, { useState } from 'react';
import { Container } from './ui/Container';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQSectionProps {
  items: FAQItem[];
}
export function FAQSection({
  items
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto" data-id="element-23">
      <div className="space-y-4" data-id="element-24">
        {items.map((item, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-25">
            <button className="flex w-full items-center justify-between px-6 py-4 text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-26">
              <span className="text-base font-semibold text-gray-900" data-id="element-27">
                {item.question}
              </span>
              {openIndex === index ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-28" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-29" />}
            </button>
            <div className={`px-6 text-gray-600 transition-all duration-200 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
              {item.answer}
            </div>
          </div>)}
      </div>
    </div>;
}